import { Breadcrumb } from '@components/breadcrumb';
import { useFragment } from 'react-relay';
import { TypeMap } from './lib';
import { cutoffListPageFragment } from './lib/CutOffListPage.relay';
import type { CutOffListPageProps } from './types';

export const CutOffListPage: React.FC<CutOffListPageProps> = (props) => {
  const page = useFragment(cutoffListPageFragment, props.page);

  return (
    <div>
      <Breadcrumb data={page.breadcrumbs} />
      <div className="pt-20 max-[600px]:pt-10">
        {page.components?.edges?.map((edge) => {
          if (!edge?.node) {
            return null;
          }
          const Type = TypeMap[edge.node.__typename];
          if (!Type) {
            return null;
          }
          return <Type key={edge.node.__typename} path={page.id} component={edge.node} location={location} />;
        })}
      </div>
    </div>
  );
};
